import { Link } from 'react-router-dom';
import './SeriesNav.css';

/**
 * 取扱シリーズ一覧 — mini pill nav for security camera series subpages.
 * Pass the current series id so it renders as active (non-clickable).
 * Series without a subpage yet gracefully fall back to the series anchor
 * on the main 防犯カメラ page.
 */
const SERIES = [
  { id: 'ip', label: 'IPカメラ', to: '/services/security-camera/ip-camera' },
  { id: 'active', label: 'アクティブ防犯', to: '/services/security-camera/active-deterrence-camera' },
  { id: 'colorvu', label: 'Super ColorVu', to: '/services/security-camera/super-colorvu' },
  { id: 'ptz', label: 'PTZカメラ', to: '/services/security-camera/ptz-camera' },
  { id: 'ir', label: 'IRナイトビジョン', to: '/services/security-camera/ir-night-vision' },
  { id: 'lpr', label: 'LPRカメラ', to: '/services/security-camera/lpr-ip-camera' },
  { id: 'mini', label: 'Mini / Fisheye', to: '/services/security-camera/mini-hidden-fisheye' },
  { id: 'wifi', label: 'WiFiカメラ', to: '/services/security-camera/wifi-camera' },
  { id: 'analog', label: 'Analog', to: '/services/security-camera/analog-camera' },
  { id: 'nvr', label: 'NVR・録画機器', to: '/services/security-camera/nvr-recorder' },
];

const SeriesNav = ({ currentId }) => {
  return (
    <div className="series-nav" data-testid="series-nav" aria-label="取扱シリーズ一覧">
      <span className="series-nav-label">取扱シリーズ一覧</span>
      <ul className="series-nav-list">
        {SERIES.map((s) => {
          const isActive = s.id === currentId;
          return (
            <li key={s.id}>
              {isActive ? (
                <span
                  className="series-nav-pill is-active"
                  data-testid={`series-nav-${s.id}`}
                  aria-current="page"
                >
                  {s.label}
                </span>
              ) : (
                <Link
                  to={s.to}
                  className="series-nav-pill"
                  data-testid={`series-nav-${s.id}`}
                >
                  {s.label}
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SeriesNav;
